"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inspectBoth = exports.inspectErr = exports.inspectOk = exports.inspectBothOfResult = exports.inspectErrOfResult = exports.inspectOkOfResult = void 0;
function noop(_v) { }
/**
 *  * Return _input_ directly.
 *      * This value is passed as the input. But it maybe mutated by calling _effector_.
 *  * Call _effector_ with the inner value of _input_ if _input_ is `Ok(T)`.
 *  * This main purpose is to inspect an inner value in a chained function calling.
 *    If you don't have to do it, you should not mutate the inner value.
 *    if-else statement might be sufficient to mutate the inner value instead of calling this function.
 */
function inspectOkOfResult(input, effector) {
    return inspectBothOfResult(input, effector, noop);
}
exports.inspectOkOfResult = inspectOkOfResult;
/**
 *  * Return _input_ directly.
 *      * This value is passed as the input. But it maybe mutated by calling _effector_.
 *  * Call _effector_ with the inner value of _input_ if _input_ is `Err(E)`.
 *  * This main purpose is to inspect an inner value in a chained function calling.
 *    If you don't have to do it, you should not mutate the inner value.
 *    if-else statement might be sufficient to mutate the inner value instead of calling this function.
 */
function inspectErrOfResult(input, effector) {
    return inspectBothOfResult(input, noop, effector);
}
exports.inspectErrOfResult = inspectErrOfResult;
/**
 *  * Return _input_ directly.
 *      * This value is passed as the input. But it maybe mutated by calling _effector_.
 *  * Call _okEffector_ with the inner value of _input_ if _input_ is `Ok(T)`.
 *    Otherwise, call _errEffector_ with the inner value if _input_ is `Err(E)`
 *  * This main purpose is to inspect an inner value in a chained function calling.
 *    If you don't have to do it, you should not mutate the inner value.
 *    if-else statement might be sufficient to mutate the inner value instead of calling this function.
 */
function inspectBothOfResult(input, okEffector, errEffector) {
    if (input.ok) {
        okEffector(input.val);
    }
    else {
        errEffector(input.err);
    }
    return input;
}
exports.inspectBothOfResult = inspectBothOfResult;
/**
 *  @deprecated
 *  Use {@link inspectOkOfResult}
 */
exports.inspectOk = inspectOkOfResult;
/**
 *  @deprecated
 *  Use {@link inspectErrOfResult}
 */
exports.inspectErr = inspectErrOfResult;
/**
 *  @deprecated
 *  Use {@link inspectBothOfResult}
 */
exports.inspectBoth = inspectBothOfResult;
